import { render } from "./Styleguide-FieldUsage-ItemLink.vue?vue&type=template&id=f20e9e7a"
import script from "./Styleguide-FieldUsage-ItemLink.vue?vue&type=script&lang=js"
export * from "./Styleguide-FieldUsage-ItemLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__